import { InjectionToken } from '@angular/core';
import { PresentationBuilderAdapter } from './adapters';
import { PresentationBuilderValueAccessor } from './value-accessors';

export interface TinymceEditorOptions {
  apiKey: string;
  plugins?: string;
  menubar?: string;
  toolbar?: string;
  options?: Record<string, unknown>;
}

export const TINYMCE_EDITOR_OPTIONS = new InjectionToken<TinymceEditorOptions>(
  'Tiny MCE '
);

export const providePresentationBuilder = <S, T>(
  adapter: typeof PresentationBuilderAdapter<S, T>,
  valueAccessor: typeof PresentationBuilderValueAccessor<T>
) => [
  {
    provide: PresentationBuilderAdapter,
    useClass: adapter,
  },
  {
    provide: PresentationBuilderValueAccessor,
    useClass: valueAccessor,
  },
];
